import { usePathname } from 'next/navigation'

import { useAnalytics } from '@flecto/analytics'
import { type FlectoAnalyticsEvents } from '@flecto/analytics/src/events'
import { type UNSAFE_any } from '@flecto/types'
import { isInsideIframe } from '@flecto/utils'

import { useStoreDates } from './useStoreDates'
import { useStoreDetails } from './useStoreDetails'

export function useStoreAnalytics() {
  const track = useAnalytics('gtm')
  const isIframe = isInsideIframe()
  const store = useStoreDetails()
  const pathname = usePathname()

  const { startAt, endAt } = useStoreDates()

  const enhancedTrack = (
    event: keyof FlectoAnalyticsEvents,
    payload: Record<string, UNSAFE_any>,
    options?: { excludeDates?: boolean }
  ) => {
    const basePayload: Record<string, UNSAFE_any> = {
      ...payload,
      is_iframe: isIframe,
      is_custom_domain: !!store?.apex_domain,
      page: pathname.includes('/items') ? 'item_details' : 'item_list',
    }

    if (!options?.excludeDates) {
      basePayload.start_date = startAt ?? ''
      basePayload.end_date = endAt ?? ''
    }

    track(event, basePayload)
  }

  return { track: enhancedTrack }
}
